import 'css-chunksrc/client/scenes/weekTimeRecords/styles.scss';export default {
  "weekTimeRecords": "_weekTimeRecords_y7xa1_1",
  "header": "_header_y7xa1_8",
  "title": "_title_y7xa1_15",
  "count": "_count_y7xa1_26",
  "headerRight": "_headerRight_y7xa1_34",
  "configuration": "_configuration_y7xa1_42",
  "cogIcon": "_cogIcon_y7xa1_47",
  "total": "_total_y7xa1_56",
  "table": "_table_y7xa1_62",
  "actions": "_actions_y7xa1_78",
  "empty": "_empty_y7xa1_82"
};